module.exports = __webpack_public_path__ + "static/media/5DPO9.372bfafc.jpg";